import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';

export type FabricStorageInfoSyncCallbackData = {
  /**
   * 当前 storage 中所有的 key
   */
  keys: string[];
  /**
   * 当前占用的空间大小, 单位 KB
   */
  currentSize: number;
  /**
   * 限制的空间大小，单位 KB
   */
  limitSize: number;
};

export type FabricStorageGetStorageSyncInfoApi =
  () => FabricStorageInfoSyncCallbackData;
/**
 * 同步接口, 获取当前storage的相关信息
 * @returns Promise<FabricStorageInfoCallbackData>
 */
export const getStorageInfoSync: FabricStorageGetStorageSyncInfoApi = () => {
  const result = core.call<
    'fabric_storage.getStorageInfoSync',
    null,
    FabricStorageInfoSyncCallbackData
  >('fabric_storage.getStorageInfoSync', null);
  const fabricErrors = filterFabricErrors(
    result.code,
    result.message,
    result.data
  );
  if (fabricErrors) {
    throw fabricErrors;
  } else {
    return result.data;
  }
};
